export enum Mode {
    Initial = 'initial',
    Completed = 'completed',
    PreviewGeneration = 'previewGeneration',
    DataLoaded = 'dataLoaded',
    HasError = 'hasError',
    ErrorCorrected = 'errorCorrected',
    SyncInProgress = 'syncInProgress',
    DataSavedToMaster = 'dataSavedToMaster'
}

export enum ButtonTitles {
    GBB_PUBLIC = 'GBB Public',
    CANCEL = 'Cancel',
    MAP_NOW = 'Map now',
    OK = 'Ok'
}

export enum IndicatorCopyTitles {
    MAIN = 'Copy & create new indicator',
    CREATE_CATEGORY = 'Copy & create new indicator: Create Category',
    CREATE_SUB_CATEGORY = 'Copy & create new indicator: Create Sub-Category'
}

export enum NestCreationTypes {
    CATEGORY = 'category',
    SUB_CATEGORY = 'sub-category'
}
